// import React, { useEffect, useMemo, useState } from "react";
// import Header from "../../components/Header";
// import classes from "./ZipGameResult.module.css";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   FaArrowLeft,
//   FaHouse,
//   FaRotateRight,
//   FaTrophy,
//   FaClock,
//   FaRoute,
//   FaBolt,
//   FaMedal,
//   FaStar,
//   FaCircleCheck,
//   FaCircleXmark,
//   FaChartLine,
// } from "react-icons/fa6";
// import BottomNavbarZipGame from "../../components/ZipGame/BottomNavbarZipGame";
// import { zipGameLeaderboardApi, zipGameResult } from "../../http/http";
// import { useSelector } from "react-redux";

// const ZipGameResult = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const { userZip } = useSelector((state) => state?.persisted?.userZipGameTokenSlice);

//   const [result, setResult] = useState({});

//   const [leaderboard, setLeaderboard] = useState([]);
//   const [userRank, setUserRank] = useState([]);

//   const fetchResult = async (game_trx_id) => {
//     try {
//       const response = await zipGameResult(game_trx_id, userZip?.token);
//       console.log(response, 'response==');
//       setResult(response?.data?.result?.[0]);

//       console.log(response?.data?.result?.[0]?.created_at);
//       const createdAt = response?.data?.result?.[0]?.created_at;
//       const onlyDate = createdAt?.split(" ")?.[0];
//       console.log(onlyDate, 'onlyDate');

//       const response2 = await zipGameLeaderboardApi(onlyDate, userZip?.token);
//       console.log(response2?.data, 'response2');
//       setLeaderboard(response2?.data?.result?.leaderboard);
//       setUserRank(response2?.data?.result?.userRank);
//     } catch (error) {
//       console.log(error, 'error=');
//     }
//   }

//   useEffect(() => {
//     if (location?.state?.game_trx_id) {
//       fetchResult(location?.state?.game_trx_id);
//     }
//     else {
//       navigate("/zip-game-details");
//     }
//   }, [location]);

//   const getInitials = (name) => {
//     if (!name) return "U";
//     return name
//       .split(" ")
//       .map((item) => item[0])
//       .join("")
//       .slice(0, 2)
//       .toUpperCase();
//   };

//   function formatTime(totalSeconds) {
//     if (totalSeconds) {
//       const mm = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
//       const ss = String(totalSeconds % 60).padStart(2, "0");
//       return `${mm}:${ss}`;
//     }
//   }

//   const leaderboardData = [
//     { id: 1, name: "Rahul", score: 2450 },
//     { id: 2, name: "Aman", score: 2210 },
//     { id: 3, name: "Sophia", score: 1980 },
//     { id: 4, name: "Daniel", score: 1760 },
//     { id: 5, name: "Neha", score: 1620 },
//   ];

//   return (
//     <>
//       <Header />

//       <div className={classes.container}>
//         <div className={classes.headerSection}>
//           <button
//             className={classes.backButton}
//             onClick={() => navigate("/zip-game-details")}
//             type="button"
//           >
//             <FaArrowLeft className={classes.backIcon} />
//           </button>

//           <h2 className={classes.headerText}>Zip Game Result</h2>
//         </div>

//         <div className={classes.heroSection}>
//           <div className={`${classes.resultIconWrap} ${classes.resultIconWin}`}>
//             <FaTrophy className={classes.resultMainIcon} />
//           </div>

//           <h1 className={`${classes.resultTitle} ${classes.statusWin}`}>
//             Zip Completed!
//           </h1>

//           {/* <p className={classes.resultSubtitle}>{resultMeta.subheading}</p> */}

//           {/* <div className={`${classes.pointsBadge} ${resultMeta.badgeClass}`}>
//             <FaMedal className={classes.pointsIcon} />
//             <span>{points} Points</span>
//           </div> */}

//           {/* <div className={classes.starsRow}>{renderStars()}</div> */}
//         </div>

//         <div className={classes.statsCard}>
//           <div className={classes.statsHeader}>Performance Summary</div>

//           <div className={classes.statsGrid}>
//             {/* <div className={classes.statBox}>
//               <div className={classes.statIconWrap}>
//                 <FaChartLine className={classes.statIcon} />
//               </div>
//               <p className={classes.statLabel}>Completion</p>
//               <h3 className={classes.statValue}>100%</h3>
//             </div> */}

//             <div className={classes.statBox}>
//               <div className={classes.statIconWrap}>
//                 <FaClock className={classes.statIcon} />
//               </div>
//               <p className={classes.statLabel}>Time</p>
//               <h3 className={classes.statValue}>{formatTime(result?.total_time_seconds)}</h3>
//             </div>

//             <div className={classes.statBox}>
//               <div className={classes.statIconWrap}>
//                 <FaRoute className={classes.statIcon} />
//               </div>
//               <p className={classes.statLabel}>Moves</p>
//               <h3 className={classes.statValue}>{result?.moves}</h3>
//             </div>

//             {/* <div className={classes.statBox}>
//               <div className={classes.statIconWrap}>
//                 <FaBolt className={classes.statIcon} />
//               </div>
//               <p className={classes.statLabel}>Difficulty</p>
//               <h3 className={classes.statValue}>Hard</h3>
//             </div> */}
//           </div>

//           {/* <div className={classes.detailsPanel}>
//               <div className={classes.detailRow}>
//                 <span className={classes.detailLabel}>Board Size</span>
//                 <span className={classes.detailValue}>{boardSize}</span>
//               </div>

//               <div className={classes.detailRow}>
//                 <span className={classes.detailLabel}>Checkpoints</span>
//                 <span className={classes.detailValue}>
//                   {checkpointsReached}/{totalCheckpoints}
//                 </span>
//               </div>
//             </div> */}
//         </div>

//         <div className={classes.section_card}>
//           <div className={classes.section_header}>
//             <div className={classes.title_with_icon}>
//               <FaTrophy className={classes.trophy_icon} />
//               <p className={classes.section_title}>Leaderboard</p>
//             </div>
//             <span className={classes.leaderboard_badge}>Top Players (19-03-2026)</span>
//           </div>

//           <div className={classes.leaderboard_list}>
//             {leaderboardData.map((player, index) => (
//               <div
//                 key={player.id}
//                 className={`${classes.leaderboard_item} ${index === 0 ? classes.first_rank : ""
//                   }`}
//               >
//                 <div className={classes.leaderboard_left}>
//                   <div
//                     className={`${classes.rank_badge} ${index === 0
//                       ? classes.rank_one
//                       : index === 1
//                         ? classes.rank_two
//                         : index === 2
//                           ? classes.rank_three
//                           : classes.rank_default
//                       }`}
//                   >
//                     #{index + 1}
//                   </div>

//                   <div className={classes.avatar_circle}>
//                     {getInitials(player.name)}
//                   </div>

//                   <div className={classes.player_info}>
//                     <p className={classes.player_name}>{player.name}</p>
//                     <p className={classes.player_status}>Zip Master</p>
//                   </div>
//                 </div>

//                 <div className={classes.score_box}>
//                   <p className={classes.score_value}>{player.score}</p>
//                   <p className={classes.score_label}>seconds</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//       </div>

//       <BottomNavbarZipGame />
//     </>
//   );
// };

// export default ZipGameResult;



import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import classes from "./ZipGameResult.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaRotateRight,
  FaTrophy,
  FaClock,
  FaRoute,
  FaMedal,
} from "react-icons/fa6";
import BottomNavbarZipGame from "../../components/ZipGame/BottomNavbarZipGame";
import { zipGameLeaderboardApi, zipGameResult } from "../../http/http";
import { useSelector } from "react-redux";

const ZipGameResult = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { userZip } = useSelector(
    (state) => state?.persisted?.userZipGameTokenSlice
  );

  // const isCurrentUser = String(player?.msisdn) === String(userZip?.msisdn);

  const [result, setResult] = useState({});
  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);

  const getPlayedDateTime = (data = {}) => {
    return data?.played_at || data?.created_at || data?.datetime || "";
  };

  const getOnlyDate = (dateTime = "") => {
    if (!dateTime) return "";
    return String(dateTime).split(" ")[0];
  };

  const formatDisplayDate = (dateTime = "") => {
    const onlyDate = getOnlyDate(dateTime);
    if (!onlyDate) return "--";
    const [year, month, day] = onlyDate.split("-");
    return `${day}-${month}-${year}`;
  };

  const formatDisplayTime = (dateTime = "") => {
    if (!dateTime) return "--";
    const timePart = String(dateTime).split(" ")[1];
    return timePart || "--";
  };

  const maskMsisdn = (value) => {
    const str = String(value || "");
    if (!str) return "Unknown";
    if (str.length <= 2) return str;
    return `****${str.slice(-3)}`;
  };

  // const getInitials = (value) => {
  //   const str = String(value || "U");
  //   return str.slice(-2).toUpperCase();
  // };

  const getInitials = (value) => {
  const str = String(value || "User").trim();
  const parts = str.split(/\s+/).filter(Boolean);

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return (parts[0][0] + parts[1][0]).toUpperCase();
};

  const formatTime = (totalSeconds) => {
    if (totalSeconds === 0) return "00:00";
    if (totalSeconds === null || totalSeconds === undefined) return "--:--";

    const mm = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const ss = String(totalSeconds % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const fetchResult = async (game_trx_id) => {
    try {
      const response = await zipGameResult(game_trx_id, userZip?.token);
      const resultData = response?.data?.result?.[0] || {};

      setResult(resultData);

      const playedDateTime = getPlayedDateTime(resultData);
      const onlyDate = getOnlyDate(playedDateTime);

      if (!onlyDate) {
        setLeaderboard([]);
        setUserRank(null);
        return;
      }

      const response2 = await zipGameLeaderboardApi(onlyDate, userZip?.token);

      setLeaderboard(response2?.data?.result?.leaderboard || []);
      setUserRank(response2?.data?.result?.userRank?.[0] || null);
    } catch (error) {
      console.log(error, "error=");
      setLeaderboard([]);
      setUserRank(null);
    }
  };

  useEffect(() => {
    if (location?.state?.game_trx_id) {
      fetchResult(location?.state?.game_trx_id);
    } else {
      navigate("/zip-game-details");
    }
  }, [location?.state?.game_trx_id, userZip?.token]);

  const playedAt = getPlayedDateTime(result);

  return (
    <>
      <Header />

      <div className={classes.container}>
        <div className={classes.headerSection}>
          <button
            className={classes.backButton}
            onClick={() => navigate("/zip-game-details")}
            type="button"
          >
            <FaArrowLeft className={classes.backIcon} />
          </button>

          <h2 className={classes.headerText}>Zip Game Result</h2>
        </div>

        <div className={classes.heroSection}>
          <div className={`${classes.resultIconWrap} ${classes.resultIconWin}`}>
            <FaTrophy className={classes.resultMainIcon} />
          </div>

          <h1 className={`${classes.resultTitle} ${classes.statusWin}`}>
            Zip Completed!
          </h1>

          <p className={classes.resultSubtitle}>
            Great job! Your game stats and leaderboard rank are shown below.
          </p>
        </div>

        <div className={classes.statsCard}>
          <div className={classes.statsHeader}>Performance Summary</div>

          <div className={classes.statsGrid}>
            <div className={classes.statBox}>
              <div className={classes.statIconWrap}>
                <FaClock className={classes.statIcon} />
              </div>
              <p className={classes.statLabel}>Time</p>
              <h3 className={classes.statValue}>
                {formatTime(result?.total_time_seconds)}
              </h3>
            </div>

            <div className={classes.statBox}>
              <div className={classes.statIconWrap}>
                <FaRoute className={classes.statIcon} />
              </div>
              <p className={classes.statLabel}>Moves</p>
              <h3 className={classes.statValue}>{result?.moves ?? "--"}</h3>
            </div>

            <div className={classes.statBox}>
              <div className={classes.statIconWrap}>
                <FaMedal className={classes.statIcon} />
              </div>
              <p className={classes.statLabel}>Your Rank</p>
              <h3 className={classes.statValue}>
                {userRank?.user_rank ? `#${userRank.user_rank}` : "--"}
              </h3>
            </div>

            <div className={classes.statBox}>
              <div className={classes.statIconWrap}>
                <FaTrophy className={classes.statIcon} />
              </div>
              <p className={classes.statLabel}>Played On</p>
              <h3 className={classes.statValueSmall}>
                {formatDisplayDate(playedAt)}
              </h3>
            </div>
          </div>

          <div className={classes.detailsPanel}>
            <div className={classes.detailRow}>
              <span className={classes.detailLabel}>Game Transaction ID</span>
              <span className={classes.detailValue}>
                {result?.game_trx_id || "--"}
              </span>
            </div>

            <div className={classes.detailRow}>
              <span className={classes.detailLabel}>Played Date</span>
              <span className={classes.detailValue}>
                {formatDisplayDate(playedAt)}
              </span>
            </div>

            <div className={classes.detailRow}>
              <span className={classes.detailLabel}>Played Time</span>
              <span className={classes.detailValue}>
                {formatDisplayTime(playedAt)}
              </span>
            </div>

            <div className={classes.detailRow}>
              <span className={classes.detailLabel}>Current Rank</span>
              <span className={classes.detailValue}>
                {userRank?.user_rank ? `#${userRank.user_rank}` : "--"}
              </span>
            </div>
          </div>
        </div>

        <div className={classes.section_card}>
          <div className={classes.section_header}>
            <div className={classes.title_with_icon}>
              <FaTrophy className={classes.trophy_icon} />
              <p className={classes.section_title}>Leaderboard</p>
            </div>
            <span className={classes.leaderboard_badge}>
              Top Players ({formatDisplayDate(playedAt)})
            </span>
          </div>

          <div className={classes.leaderboard_list}>
            {leaderboard?.length > 0 ? (
              leaderboard.map((player, index) => {
                const isCurrentUser =
                  String(player?.msisdn) === String(userZip?.msisdn);

                return (
                  <div
                    key={player?.game_trx_id || `${player?.msisdn}-${index}`}
                    className={`${classes.leaderboard_item} ${
                      index === 0 ? classes.first_rank : ""
                    } ${isCurrentUser ? classes.highlightMe : ""}`}
                  >
                    <div className={classes.leaderboard_left}>
                      <div
                        className={`${classes.rank_badge} ${
                          index === 0
                            ? classes.rank_one
                            : index === 1
                            ? classes.rank_two
                            : index === 2
                            ? classes.rank_three
                            : classes.rank_default
                        }`}
                      >
                        #{player?.user_rank}
                      </div>

                      <div className={classes.avatar_circle}>
                        {getInitials(player?.name)}
                      </div>

                      <div className={classes.player_info}>
                        <p className={classes.player_name}>
                          {maskMsisdn(player?.msisdn)}
                        </p>
                        <p className={classes.player_status}>
                          Moves: {player?.moves ?? 0}
                          {isCurrentUser ? " • You" : ""}
                        </p>
                      </div>
                    </div>

                    <div className={classes.score_box}>
                      <p className={classes.score_value}>
                        {formatTime(player?.total_time_seconds)}
                      </p>
                      <p className={classes.score_label}>time</p>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={classes.noDataCard}>
                <p className={classes.noDataText}>
                  No leaderboard data available for this date.
                </p>
              </div>
            )}
          </div>
        </div>
      
      </div>

      <BottomNavbarZipGame />
    </>
  );
};

export default ZipGameResult;